<template>
    <div class="our-brand container">
        <h2>{{ this.title }}</h2>
        <!-- 5 x 3 -->
        <div class="blocks brand-tails">
            <div
                v-if="imageBlock1"
                class="block brand-tail block--grey"
                @click="setActiveBrand($event)"
                :class="{'block--active': 0 === activeBrand }"
            >
                <div class="brand-tail__header">
                    <img :src="imageBlock1" alt="logo" data-index="0" />
                </div>
                <div
                    class="brand-tail__content"
                    :class="{'brand-tail__content--active': 0 === activeBrand }"
                >
                    <div class="brand-tail__content-top">
                        <div class="cross" @click="hideContent"></div>
                    </div>
                    <div class="brand-tail__content-inner">
                        <div
                            v-if="imageBlock1"
                            class="brand-tail__content-image"
                            :style="{'background-color': images[0].left_background }"
                        >
                            <img :src="imageBlock1" alt="image" />
                        </div>
                        <div
                            class="brand-tail__content-description"
                            :style="{'background-color': images[0].right_background, 'color': images[0].right_text_color }"
                            v-html="images[0].description"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="block block--white"></div>
            <div class="block block--triple">
                <p class="description">{{ this.description }}</p>
            </div>
            <div v-if="imageBlock2" class="block block--white"></div>
            <div
                v-if="imageBlock2"
                class="block block--grey"
                @click="setActiveBrand($event)"
                :class="{'block--active': 1 === activeBrand }"
            >
                <div class="brand-tail__header">
                    <img :src="imageBlock2" alt="logo" data-index="1" />
                </div>
                <div
                    class="brand-tail__content"
                    :class="{'brand-tail__content--active': 1 === activeBrand }"
                >
                    <div class="brand-tail__content-top">
                        <div class="cross" @click="hideContent"></div>
                    </div>
                    <div class="brand-tail__content-inner">
                        <div
                            v-if="imageBlock2"
                            class="brand-tail__content-image"
                            :style="{'background-color': images[1].left_background }"
                        >
                            <img :src="imageBlock2" alt="image" />
                        </div>
                        <div
                            class="brand-tail__content-description"
                            :style="{'background-color': images[1].right_background, 'color': images[1].right_text_color }"
                            v-html="images[1].description"
                        ></div>
                    </div>
                </div>
            </div>
            <div v-if="imageBlock3" class="block block--white"></div>
            <div
                v-if="imageBlock3"
                class="block block--grey"
                @click="setActiveBrand($event)"
                :class="{'block--active': 2 === activeBrand }"
            >
                <div class="brand-tail__header">
                    <img :src="imageBlock3" alt="logo" data-index="2" />
                </div>
                <div
                    class="brand-tail__content"
                    :class="{'brand-tail__content--active': 2 === activeBrand }"
                >
                    <div class="brand-tail__content-top">
                        <div class="cross" @click="hideContent"></div>
                    </div>
                    <div class="brand-tail__content-inner">
                        <div
                            v-if="imageBlock3"
                            class="brand-tail__content-image"
                            :style="{'background-color': images[2].left_background }"
                        >
                            <img :src="imageBlock3" alt="image" />
                        </div>
                        <div
                            class="brand-tail__content-description"
                            :style="{'background-color': images[2].right_background, 'color': images[2].right_text_color }"
                            v-html="images[2].description"
                        ></div>
                    </div>
                </div>
            </div>
            <div v-if="imageBlock4" class="block block--white"></div>
            <div
                v-if="imageBlock4"
                class="block block--grey"
                @click="setActiveBrand($event)"
                :class="{'block--active': 3 === activeBrand }"
            >
                <div class="brand-tail__header">
                    <img :src="imageBlock4" alt="logo" data-index="3" />
                </div>
                <div
                    class="brand-tail__content"
                    :class="{'brand-tail__content--active': 3 === activeBrand }"
                >
                    <div class="brand-tail__content-top">
                        <div class="cross" @click="hideContent"></div>
                    </div>
                    <div class="brand-tail__content-inner">
                        <div
                            v-if="imageBlock4"
                            class="brand-tail__content-image"
                            :style="{'background-color': images[3].left_background }"
                        >
                            <img :src="imageBlock4" alt="image" />
                        </div>
                        <div
                            class="brand-tail__content-description"
                            :style="{'background-color': images[3].right_background, 'color': images[3].right_text_color }"
                            v-html="images[3].description"
                        ></div>
                    </div>
                </div>
            </div>
            <div v-if="imageBlock5" class="block block--white"></div>
            <div
                v-if="imageBlock5"
                class="block block--grey"
                @click="setActiveBrand($event)"
                :class="{'block--active': 4 === activeBrand }"
            >
                <div class="brand-tail__header">
                    <img :src="imageBlock5" alt="logo" data-index="4" />
                </div>
                <div
                    class="brand-tail__content"
                    :class="{'brand-tail__content--active': 4 === activeBrand }"
                >
                    <div class="brand-tail__content-top">
                        <div class="cross" @click="hideContent"></div>
                    </div>
                    <div class="brand-tail__content-inner">
                        <div
                            v-if="imageBlock5"
                            class="brand-tail__content-image"
                            :style="{'background-color': images[4].left_background }"
                        >
                            <img :src="imageBlock5" alt="image" />
                        </div>
                        <div
                            class="brand-tail__content-description"
                            :style="{'background-color': images[4].right_background, 'color': images[4].right_text_color }"
                            v-html="images[4].description"
                        ></div>
                    </div>
                </div>
            </div>
            <div v-if="imageBlock6" class="block block--white"></div>
            <div
                v-if="imageBlock6"
                class="block block--grey"
                @click="setActiveBrand($event)"
                :class="{'block--active': 5 === activeBrand }"
            >
                <div class="brand-tail__header">
                    <img :src="imageBlock6" alt="logo" data-index="5" />
                </div>
                <div
                    class="brand-tail__content"
                    :class="{'brand-tail__content--active': 5 === activeBrand }"
                >
                    <div class="brand-tail__content-top">
                        <div class="cross" @click="hideContent"></div>
                    </div>
                    <div class="brand-tail__content-inner">
                        <div
                            v-if="imageBlock6"
                            class="brand-tail__content-image"
                            :style="{'background-color': images[5].left_background }"
                        >
                            <img :src="imageBlock6" alt="image" />
                        </div>
                        <div
                            class="brand-tail__content-description"
                            :style="{'background-color': images[5].right_background, 'color': images[5].right_text_color }"
                            v-html="images[5].description"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-our-brand",
    data() {
        return {
            activeBrand: -1,
            title: this.blockdata.title,
            description: this.blockdata.description,
            images: this.blockdata.images,
            imageBlock1: this.blockdata.images[0] ? this.blockdata.images[0].image.url : null,
            imageBlock2: this.blockdata.images[1] ? this.blockdata.images[1].image.url : null,
            imageBlock3: this.blockdata.images[2] ? this.blockdata.images[2].image.url : null,
            imageBlock4: this.blockdata.images[3] ? this.blockdata.images[3].image.url : null,
            imageBlock5: this.blockdata.images[4] ? this.blockdata.images[4].image.url : null,
            imageBlock6: this.blockdata.images[5] ? this.blockdata.images[5].image.url : null
        };
    },
    methods: {
        setActiveBrand: function(event) {
            const newActiveBrand = Number(event.target.dataset.index);

            if (this.activeBrand === newActiveBrand) {
                this.activeBrand = -1;
            } else {
                this.activeBrand = Number(event.target.dataset.index);
            }
        },
        hideContent: function() {
            this.activeBrand = -1;
        }
    }
};
</script>



// WEBPACK FOOTER //
// BlockOurBrand.vue?4a414a7e